import * as React from 'react';
import { IChatMessage } from '../../../model/chatmessage';
import { Message } from './Message';

interface IMessagesProps {
  sub: string;
  chatMessages: Array<IChatMessage>;

}

interface IMessagesState {
}

export class ListMessages extends React.Component<IMessagesProps, IMessagesState> {

  render() {
    return this.props.chatMessages  ? this.props.chatMessages.map(m => <Message message={m} key={m._id} />) : null
  }
}

// export const ListMessages = Messages;